import { GUEST } from 'constants/constants';
import useUser from 'hooks/user/useUser';

const useHasRequiredRole = (role = GUEST) => {
  const [me] = useUser();
  if (!me) return false;
  const { roles = [] } = me;
  return roles.includes(role);
};

export default useHasRequiredRole;
